<ng-container>
    <ng-container>
        <div
            *ngIf="configValue"
            class="mainLayout"
            [ngClass]="isRtl == 'rtl' ? 'rtl' : 'ltr'"
            (scroll)="onScrollEvent($event)"
        >
            <mat-sidenav-container>
                <ng-container
                    *ngIf="configValue.code != '700' && !hideHeaderFooter"
                >
                    <ng-container>
                        <mat-sidenav
                            #sidenav
                            [(opened)]="embryoService.sidenavOpen"
                            class="sidebar-area"
                            mode="over"
                        >
                            <mat-nav-list>
                                <div class="close-btn-sidebar">
                                    <a
                                        href="javascript:void(0)"
                                        (click)="
                                            embryoService.sidenavOpen = false
                                        "
                                    >
                                        <mat-icon
                                            class="material-icons"
                                            aria-hidden="false"
                                        >
                                            close
                                        </mat-icon>
                                    </a>
                                </div>
                                <div
                                    *ngIf="
                                        menuItems?.level1?.length;
                                        else loadingTemplate
                                    "
                                >
                                    <embryo-SidebarMenu
                                        *ngFor="
                                            let item of menuItems?.level1;
                                            let i = index
                                        "
                                        [item]="item"
                                        [lang]="lang"
                                    >
                                    </embryo-SidebarMenu>

                                    <a
                                        *ngIf="configValue?.ENABLE_STATIC_MENU"
                                        class="nav-link main extra-items-deals"
                                        (click)="
                                            clickedItem = true;
                                            embryoService.sidenavOpen = false
                                        "
                                        routerLinkActive="active-link"
                                        (mouseleave)="clickedItem = false"
                                        [routerLink]="[
                                            '/' + lang + '/products/deals'
                                        ]"
                                        [queryParams]="{sort:'high-discount'}"

                                    >
                                        {{ "deals" | translate }}
                                    </a>

                                    <a
                                        class="link extra-items-prescrptions"
                                        *ngIf="
                                            configValue?.enable_prescription &&
                                            configValue?.ENABLE_STATIC_MENU
                                        "
                                        (click)="
                                            embryoService.sidenavOpen = false
                                        "
                                        [routerLink]="[
                                            '/' + lang + '/prescriptions'
                                        ]"
                                        >{{
                                            "prescription.medicalPrescription"
                                                | translate
                                        }}</a
                                    >
                                </div>
                                <ng-template #loadingTemplate>
                                    <div *ngFor="let item of fakeArray">
                                        <a mat-list-item class="color-white">
                                            <mat-icon></mat-icon>
                                            <div
                                                class="ml-3 w-50 animate-shimmer shimmer-container"
                                            ></div>
                                        </a>
                                    </div>
                                </ng-template>
                            </mat-nav-list>
                        </mat-sidenav>

                        <mat-sidenav
                            class="em-sidebar"
                            #paymentSidenav
                            [(opened)]="embryoService.paymentSidenavOpen"
                            position="end"
                            mode="over"
                            style="width: 83%"
                        >
                            <embryo-PaymentDetailSideBar></embryo-PaymentDetailSideBar>
                        </mat-sidenav>
                        <div
                            *ngIf="skip_maintenance && configValue?.APP_SWITCH"
                            class="container"
                        >
                            <div class="maintainance-mode">
                                <p>{{ "return_maintenance" | translate }}</p>
                                <button
                                    (click)="maintain()"
                                    mat-raised-button
                                    color="accent"
                                    class="btn color-primary"
                                >
                                    {{ "return" | translate }}
                                </button>
                            </div>
                        </div>
                    </ng-container>

                    <!-- Menues -->
                    <ng-container>
                        <app-download-app [lang]="lang"></app-download-app>
                        <app-softbar
                            *ngIf="configValue"
                            [environmentVariables]="configValue"
                            [lang]="lang"
                        ></app-softbar>
                        <div class="test-test">
                            <mat-toolbar-row
                                fxLayoutAlign="flex-start center"
                                class="top-toolbar theme-container height-50 w-100"
                                *ngIf="
                                    (configValue?.HOTPHONE &&
                                        configValue?.ENABLE_HOTPHONE) ||
                                    configValue?.ENABLE_SHOW_MAGAZINE_LINK_IN_TOP_MENU ||
                                    configValue?.ENABLE_BLOG_TOP_MENU ||
                                    ((configValue?.STORE_ANDROID_URL ||
                                        configValue?.STORE_APPLE_URL) &&
                                        configValue?.ENABLE_APPS) ||
                                    configValue?.TOPMENU_MESSAGE
                                "
                                [ngStyle]="{
                                    'background-color':
                                        configValue?.HEADER_BACKGROUND_COLOR
                                }"
                            >
                                <span
                                    fxLayoutAlign="flex-start center"
                                    style="gap: 10px"
                                    class="mx-5"
                                >
                                    <a
                                        *ngIf="
                                            configValue?.HOTPHONE &&
                                            configValue?.ENABLE_HOTPHONE
                                        "
                                        href="tel:{{ configValue?.HOTPHONE }}"
                                        style="text-decoration: none"
                                        fxShow="false"
                                        fxShow.gt-xs
                                        [ngStyle]="{
                                            color: configValue?.HEADER_TEXT_COLOR
                                        }"
                                    >
                                        <mat-icon
                                            matSuffix
                                            class="mat-icon-sm call hover-on"
                                            style="vertical-align: middle"
                                            >call</mat-icon
                                        >
                                        {{ "header.hotline" | translate }} :
                                        &nbsp;
                                        <a
                                            href="tel:{{
                                                configValue?.HOTPHONE
                                            }}"
                                            class="mat-icon-sm call hover-on"
                                            style="text-decoration: none"
                                            [ngStyle]="{
                                                color: configValue?.HEADER_TEXT_COLOR
                                            }"
                                        >
                                            {{ configValue?.HOTPHONE }}</a
                                        >
                                    </a>
                                    <a
                                        *ngIf="
                                            (configValue?.STORE_ANDROID_URL ||
                                                configValue?.STORE_APPLE_URL) &&
                                            configValue?.ENABLE_APPS
                                        "
                                        class="secondary-color"
                                        style="margin: 0px 0px"
                                        fxShow="false"
                                        fxShow.gt-xs
                                    >
                                        <span
                                            class="download-app-ar"
                                            style="display: inline-block"
                                            [ngStyle]="{
                                                color: configValue?.HEADER_TEXT_COLOR
                                            }"
                                            >{{
                                                "header.downloadApp" | translate
                                            }}</span
                                        >
                                    </a>

                                    <a
                                        *ngIf="
                                            configValue?.STORE_ANDROID_URL &&
                                            configValue?.ENABLE_APPS
                                        "
                                        target="_blank"
                                        [href]="configValue?.STORE_ANDROID_URL"
                                        fxShow="true"
                                        style="line-height: 15px"
                                    >
                                        <app-source-icons
                                            [source_type]="'androidSvg'"
                                        ></app-source-icons>
                                    </a>

                                    <a
                                        *ngIf="
                                            configValue?.STORE_APPLE_URL &&
                                            configValue?.ENABLE_APPS
                                        "
                                        target="_blank"
                                        [href]="configValue?.STORE_APPLE_URL"
                                        fxShow="true"
                                        style="line-height: 15px"
                                    >
                                        <app-source-icons
                                            [source_type]="'appleSvg'"
                                        ></app-source-icons>
                                    </a>

                                    <a
                                        *ngIf="
                                            configValue?.ENABLE_SHOW_MAGAZINE_LINK_IN_TOP_MENU
                                        "
                                        target="_blank"
                                        href="{{
                                            configValue?.MAGAZINE_LINK_IN_TOP_MENU
                                        }}"
                                        style="
                                            margin: 0 10px;
                                            cursor: pointer;
                                            text-decoration: none;
                                        "
                                    >
                                        <span
                                            *ngIf="
                                                !configValue?.LABEL_MAGAZINE_TOP_MENU_EN &&
                                                lang == 'en'
                                            "
                                            style="text-decoration: none"
                                            [ngStyle]="{
                                                color: configValue?.HEADER_TEXT_COLOR
                                            }"
                                            >{{ "header.magazine" | translate }}
                                        </span>
                                        <span
                                            *ngIf="
                                                !configValue?.LABEL_MAGAZINE_TOP_MENU_AR &&
                                                lang == 'ar'
                                            "
                                            style="text-decoration: none"
                                            [ngStyle]="{
                                                color: configValue?.HEADER_TEXT_COLOR
                                            }"
                                            >{{ "header.magazine" | translate }}
                                        </span>
                                        <span
                                            *ngIf="
                                                configValue?.LABEL_MAGAZINE_TOP_MENU_EN &&
                                                lang == 'en'
                                            "
                                            [ngStyle]="{
                                                color: configValue?.HEADER_TEXT_COLOR
                                            }"
                                        >
                                            {{
                                                configValue?.LABEL_MAGAZINE_TOP_MENU_EN
                                            }}
                                        </span>
                                        <span
                                            *ngIf="
                                                configValue?.LABEL_MAGAZINE_TOP_MENU_AR &&
                                                lang == 'ar'
                                            "
                                            [ngStyle]="{
                                                color: configValue?.HEADER_TEXT_COLOR
                                            }"
                                        >
                                            {{
                                                configValue?.LABEL_MAGAZINE_TOP_MENU_AR
                                            }}
                                        </span>
                                    </a>
                                    <a
                                        *ngIf="
                                            configValue?.ENABLE_BLOG_TOP_MENU
                                        "
                                        [href]="
                                            lang == 'en'
                                                ? configValue?.LINK_BLOG_TOP_MENU_EN
                                                : configValue?.LINK_BLOG_TOP_MENU_AR
                                        "
                                        style="
                                            cursor: pointer;
                                            text-decoration: none;
                                        "
                                    >
                                        <span
                                            style="text-decoration: none"
                                            [ngStyle]="{
                                                color: configValue?.HEADER_TEXT_COLOR
                                            }"
                                            >{{
                                                lang == "en"
                                                    ? configValue?.LABEL_BLOG_TOP_MENU_EN
                                                    : configValue?.LABEL_BLOG_TOP_MENU_AR
                                            }}</span
                                        >
                                    </a>
                                </span>
                                <span
                                    *ngIf="configValue?.TOPMENU_MESSAGE"
                                    fxShow="false"
                                    fxShow.gt-sm
                                    [ngStyle]="{
                                        color: configValue?.HEADER_TEXT_COLOR
                                    }"
                                >
                                    {{
                                        lang == "en"
                                            ? configValue?.TOPMENU_MESSAGE_EN
                                            : configValue?.TOPMENU_MESSAGE_AR
                                    }}</span
                                >
                            </mat-toolbar-row>
                        </div>
                    </ng-container>

                    <!-- HeaderTwo -->
                    <ng-container>
                        <HeaderTwo
                            id="header-two-h"
                            class="fixed-header"
                            [Categories]="menuItems?.level1"
                            [lang]="lang"
                        ></HeaderTwo>
                    </ng-container>

                    <ng-container *ngIf="
                        homePageDataCustomAds && 
                        configValue?.enable_top_ads_on_all_pages
                    ">
                        <div
                            (click)="floatingBannerRouting(0)"
                            *ngIf="homePageDataCustomAds[0]?.active === 1"
                            class="floating-banner"
                            [ngClass]="{ pointer: homePageDataCustomAds[0]?.type == 0 }"
                            [ngStyle]="{ backgroundColor: homePageDataCustomAds[0]?.dev_key }"
                        >
                        <img loading="lazy" 
                            alt="Ads Image"
                            class="d-md-none d-block"
                            [src]="homePageDataCustomAds[0]?.image"
                        />
                        <img loading="lazy" 
                            alt="Ads Image"
                            class="d-md-block d-none"
                            [src]="homePageDataCustomAds[0]?.image_web"
                        />
                        </div>
                    </ng-container>
                </ng-container>

                <!-- Router out let -->
                <ng-container
                    *ngIf="showRouterOutlet()"
                >
                    <div class="main background-white" style="min-height: 50vh">
                        <router-outlet
                            (activate)="onActivate($event)"
                        ></router-outlet>
                        <div
                            class="flying-whatsapp-messenger"
                            *ngIf="
                                configValue?.WHATSAPP_SHOW_HIDE_SWITCH &&
                                configValue?.HOTPHONE
                            "
                        >
                            <a
                                target="_blank"
                                rel="nofollow noopener"
                                [href]="
                                    lang == 'en'
                                        ? 'https://api.whatsapp.com/send/?phone=' +
                                          configValue?.localization
                                              ?.phone_prefix +
                                          configValue?.HOTPHONE +
                                          '&text=Hello&amp;&amp;app_absent=0'
                                        : 'https://api.whatsapp.com/send/?phone=' +
                                          configValue?.localization
                                              ?.phone_prefix +
                                          configValue?.HOTPHONE +
                                          '&text=مرحبا&amp;&amp;app_absent=0'
                                "
                            >
                                <span
                                    cass="puls-circle"
                                    class="pulsing-circle"
                                ></span>
                                <img
                                    loading="lazy"
                                    src="assets/images/whatsapp2.svg"
                                    srcset="assets/images/whatsapp2.svg 1x"
                                    alt="whatsapp chat"
                                    width="44"
                                    height="44"
                                />
                            </a>
                        </div>
                    </div>

                    <ng-container *ngIf="
                        homePageDataCustomAds && 
                        configValue?.enable_bottom_ads_on_all_pages
                    ">
                        <div
                            (click)="floatingBannerRouting(1)"
                            *ngIf="homePageDataCustomAds[1]?.active === 1"
                            class="floating-banner"
                            [ngClass]="{ pointer: homePageDataCustomAds[1]?.type == 0 }"
                            [ngStyle]="{ backgroundColor: homePageDataCustomAds[1]?.dev_key }"
                        >
                        <img loading="lazy" 
                            alt="Ads Image"
                            class="d-md-none d-block"
                            [src]="homePageDataCustomAds[1]?.image"
                        />
                        <img loading="lazy" 
                            alt="Ads Image"
                            class="d-md-block d-none"
                            [src]="homePageDataCustomAds[1]?.image_web"
                        />
                        </div>
                    </ng-container>
                    
                    <ng-container *ngIf="configValue.code != '700'">
                        <FooterOne *ngIf="!hideHeaderFooter"></FooterOne>
                        <div
                            *ngIf="showBackToTop"
                            fxLayout="row"
                            fxLayoutAlign="center center"
                            class="back-to-top swiper-button-prev transition"
                            (click)="scrollToTop()"
                        ></div>
                    </ng-container>
                </ng-container>
            </mat-sidenav-container>
        </div>
        <div *ngIf="loadingRoute || !configValue" class="loadingArea">
            <app-loading></app-loading>
        </div>
        <div
            *ngIf="
                configValue?.LOYALTY_PROVIDER == 'gameBall' &&
                configValue.code != '700'
            "
            (click)="verifyPhone()"
            class="activatePhoneBtn"
        >
            <img
                loading="lazy"
                src="./../assets/images/gm-{{ lang }}.png"
                alt="language"
            />
            <div *ngIf="gmloading" class="loading">
                <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <div
            *ngIf="configValue?.CHAT_SUPPORT_PROVIDER == 'whatsapp'"
            class="flying-whatsapp-messenger"
        >
            <a
                target="_blank"
                href="https://api.whatsapp.com/send/?phone={{
                    configValue?.WHATSAPP_LINK
                }}&amp;&amp;app_absent=0"
                ><img
                    loading="lazy"
                    src="./../assets/images/whatsapp2.svg"
                    alt="whatsapp"
            /></a>
        </div>
        <ng-container
            *ngIf="
                (!configValue?.ENABLE_STATIC_MENU &&
                    !configValue?.ENABLE_MULTI_INVENTORY) ||
                (configValue?.ENABLE_MULTI_INVENTORY &&
                    ( configValue?.PICKUP_DELIVERY_SOURCE_Backup == 'both' || configValue?.PICKUP_DELIVERY_SOURCE_Backup == 'area' ) &&
                    (user?.branch || user?.area))
            "
        >
            <app-cookie-popup></app-cookie-popup>
        </ng-container>
    </ng-container>

    <!-- Multi Inventory -->
    <ng-container>
        <div
            *ngIf="checkMultiInventoryShow()"
            class="multi-invintory-area"
        >
            <app-multi-invintory-area
                (backToBothFunc)="closearea($event)"
                (closeFunc)="backandclose($event)"
            ></app-multi-invintory-area>
        </div>
        <div
            *ngIf="checkStoreAreaShow()"
            class="stores-area test2"
        >
            <div
                class="all-areas"
                fxLayout="row wrap"
                fxLayoutAlign="flex-start flex-start"
            >
                <div
                    fxFlex.sm="100"
                    fxFlex.xs="100"
                    fxFlex.md="100"
                    fxFlex.lg="100"
                    fxFlex.xl="100"
                    class="stores-header"
                >
                    <h2>
                        <span
                            *ngIf="
                                configValue.PICKUP_DELIVERY_SOURCE_Backup ==
                                'both'
                            "
                            (click)="backToBoth()"
                            class="material-icons back-btn"
                            >{{
                                lang == "en" ? "chevron_left" : "chevron_right"
                            }}</span
                        >
                        <ng-container
                            *ngIf="configValue?.PICKUP_FROM_STORE_LABEL_TEXT_EN"
                        >
                            {{
                                lang == "en"
                                    ? configValue?.PICKUP_FROM_STORE_LABEL_TEXT_EN
                                    : configValue?.PICKUP_FROM_STORE_LABEL_TEXT_AR
                            }}
                        </ng-container>
                        <ng-container
                            *ngIf="
                                !configValue?.PICKUP_FROM_STORE_LABEL_TEXT_EN
                            "
                        >
                            {{ "select_a_pickup_location" | translate }}
                        </ng-container>
                    </h2>
                    <mat-icon
                        *ngIf="user?.branch || user?.area"
                        (click)="closeBranchesPopup()"
                        >close</mat-icon
                    >
                </div>

                <div
                    fxFlex.sm="100"
                    fxFlex.xs="100"
                    fxFlex.md="100"
                    fxFlex.lg="100"
                    fxFlex.xl="100"
                    *ngIf="loadingBranches"
                    class="loading-height"
                >
                    <app-loading></app-loading>
                </div>
                <div
                    *ngIf="!loadingBranches"
                    fxLayout="row wrap"
                    fxLayoutAlign="flex-start flex-start"
                    class="all-branches"
                >
                    <div
                        *ngFor="let branch of branches"
                        (click)="branch_id = branch.id"
                        class="single-branch mrl-5"
                        fxFlex.sm="100"
                        fxFlex.xs="100"
                        fxFlex.md="32"
                        fxFlex.lg="32"
                        fxFlex.xl="32"
                        [ngClass]="{
                            'active-branch': branch_id == branch.id
                        }"
                    >
                        <h5>
                            {{
                                lang == "en"
                                    ? branch.shop_name
                                    : branch.shop_name_ar
                            }}
                        </h5>
                        <p>
                            {{
                                lang == "en"
                                    ? branch.address
                                    : branch.address_ar
                            }}
                        </p>
                        <p>
                            {{ lang == "en" ? branch.area : branch.area_ar }}
                        </p>
                        <p class="phone">
                            <span
                                *ngFor="
                                    let phone of branch.phone;
                                    let index = index
                                "
                            >
                                {{ "branches.telephone" | translate }}
                                {{ index + 1 }} :
                                <a [href]="'tel:' + phone">{{ phone }}</a>
                                <span *ngIf="index != branch.phone.length - 1"
                                    ><br
                                /></span>
                            </span>
                        </p>
                        <p class="phone">
                            <span>
                                <a
                                    target="_blank"
                                    href="{{ branch.direction_link }}"
                                    >{{
                                        "branches.getdirections" | translate
                                    }}</a
                                >
                            </span>
                        </p>
                    </div>
                    <div
                        *ngIf="
                            !branches ||
                            (branches?.length == 0 && !loadingBranches)
                        "
                        fxFlex.sm="100"
                        fxFlex.xs="100"
                        fxFlex.md="100"
                        fxFlex.lg="100"
                        fxFlex.xl="100"
                        class="no-branches"
                    >
                        {{ "no_branches" | translate }}
                    </div>
                </div>

                <div
                    fxFlex.sm="100"
                    fxFlex.xs="100"
                    fxFlex.md="100"
                    fxFlex.lg="100"
                    fxFlex.xl="100"
                    class="submit-area mt-3"
                >
                    <button
                        *ngIf="!loadingBranches"
                        (click)="submitBranch()"
                        [disabled]="!branch_id || submittingBranch"
                        class="primary-button"
                        mat-raised-button
                    >
                        {{ "source.save" | translate }}
                        <app-loading *ngIf="submittingBranch"></app-loading>
                    </button>
                </div>
            </div>
        </div>
        <div
            *ngIf="
                initilaizeData &&
                configValue?.ENABLE_MULTI_INVENTORY &&
                show_both_source
            "
            class="multi-env-both-area"
        >
            <div class="both-areas">
                <mat-icon
                    *ngIf="user?.branch || user?.area"
                    (click)="closeBothBranch()"
                    class="close-area-both"
                    >close</mat-icon
                >
                <div class="title-area">
                    <h2>{{ "Now You Can Choose Between" | translate }}</h2>
                    <h3>
                        <ng-container
                            *ngIf="configValue?.PICKUP_FROM_STORE_LABEL_TEXT_EN"
                        >
                            {{ "Delivery Or Pickup" | translate }}
                            {{
                                lang == "en"
                                    ? configValue?.PICKUP_FROM_STORE_LABEL_TEXT_EN
                                    : configValue?.PICKUP_FROM_STORE_LABEL_TEXT_AR
                            }}
                        </ng-container>
                        <ng-container
                            *ngIf="
                                !configValue?.PICKUP_FROM_STORE_LABEL_TEXT_EN
                            "
                        >
                            {{ "Delivery Or Pickup" | translate
                            }}{{ "Pickup" | translate }}
                        </ng-container>
                    </h3>
                </div>
                <div class="d-flex source-areas">
                    <div
                        class="single-source width-45"
                        (click)="setSource('area')"
                    >
                        <div class="source-icon">
                            <img
                                loading="lazy"
                                src="./../assets/images/multi-inv/area.png"
                                alt="multi inventory"
                            />
                        </div>
                        <div class="source-text">
                            <h3
                                *ngIf="
                                    !configValue?.DELIVERY_LABEL_TEXT_EN &&
                                    lang == 'en'
                                "
                            >
                                {{ "source.area" | translate }}
                            </h3>
                            <h3
                                *ngIf="
                                    !configValue?.DELIVERY_LABEL_TEXT_AR &&
                                    lang == 'ar'
                                "
                            >
                                {{ "source.area" | translate }}
                            </h3>
                            <h3
                                *ngIf="
                                    configValue?.DELIVERY_LABEL_TEXT_EN &&
                                    lang == 'en'
                                "
                            >
                                {{ configValue?.DELIVERY_LABEL_TEXT_EN }}
                            </h3>
                            <h3
                                *ngIf="
                                    configValue?.DELIVERY_LABEL_TEXT_AR &&
                                    lang == 'ar'
                                "
                            >
                                {{ configValue?.DELIVERY_LABEL_TEXT_AR }}
                            </h3>
                            <p>{{ "source.area_p" | translate }}</p>
                        </div>
                    </div>
                    <div
                        class="single-source click-colect-img"
                        (click)="setSource('store')"
                    >
                        <div class="source-icon">
                            <img
                                loading="lazy"
                                src="./../assets/images/multi-inv/store.png"
                                alt="multi inventory"
                            />
                        </div>
                        <div class="source-text">
                            <h3>
                                <ng-container
                                    *ngIf="
                                        configValue?.PICKUP_FROM_STORE_LABEL_TEXT_EN
                                    "
                                >
                                    {{
                                        lang == "en"
                                            ? configValue?.PICKUP_FROM_STORE_LABEL_TEXT_EN
                                            : configValue?.PICKUP_FROM_STORE_LABEL_TEXT_AR
                                    }}
                                </ng-container>
                                <ng-container
                                    *ngIf="
                                        !configValue?.PICKUP_FROM_STORE_LABEL_TEXT_EN
                                    "
                                >
                                    {{ "source.store" | translate }}
                                </ng-container>
                            </h3>
                            <p>{{ "source.store_p" | translate }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
</ng-container>
